module.exports = __webpack_public_path__ + "img/user2.35ff7fd8.png";